import { Directive, HostBinding, Input } from '@angular/core';
import { InlineBannerType, InlineBannerVariant } from './inline-banner';

@Directive({
  selector: '[inline-banner]'
})
export class InlineBannerDirective {
  @Input({ required: true }) variant: InlineBannerVariant;
  @Input({ required: true }) type: InlineBannerType;

  @HostBinding('class.inline-banner') readonly class = true;

  @HostBinding('class.inline-banner__variant--filled')
  get isFilled() {
    return this.variant === 'filled';
  }

  @HostBinding('class.inline-banner__type--inverse')
  get isInverse() {
    return this.type === 'inverse';
  }
}
